<template lang="pug">
  .page-content
    app-upload-cadastro
</template>

<script>
import AppUploadCadastro from '@/components/AppUploadCadastro'

export default {
  components: {
    AppUploadCadastro
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/Enviar.vue